import { MapEditorFeatureCreateOptionsSelect_ObservationFragment } from "../fragments.generated";

type IdNamePair = { id: string; name: string };

type ObservationTypeMap = Map<
    string,
    {
        observationType: MapEditorFeatureCreateOptionsSelect_ObservationFragment["observationTypes"][number];
        researchType: MapEditorFeatureCreateOptionsSelect_ObservationFragment;
    }
>;

/**
 * Builds both species list and observation type map in a single pass
 */
export function buildDataMaps(researchTypes: MapEditorFeatureCreateOptionsSelect_ObservationFragment[]) {
    const speciesMap = new Map<string, IdNamePair>();
    const observationTypeMap: ObservationTypeMap = new Map();

    researchTypes.forEach(researchType => {
        // Extract unique species
        researchType.speciesV2.forEach(({ species }) => {
            speciesMap.set(species.id, species);
        });

        // Build observation type lookup map
        researchType.observationTypes.forEach(observationType => {
            observationTypeMap.set(observationType.id, {
                observationType,
                researchType,
            });
        });
    });

    return {
        allSpecies: Array.from(speciesMap.values()).sort((a, b) => a.name.localeCompare(b.name)),
        observationTypeMap,
    };
}
